import type {ListExpedientsSearch} from "./-types";

import {listExpedientsQueryOptions} from "@project/application/sales/expedients";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {ExpedientsPage} from "./-page/expedients.page";
import {ExpedientsPending} from "./-page/expedients.pending";
import {listExpedientsSearchSchema} from "./-types";

export type {ListExpedientsSearch} from "./-types";

export const Route = createFileRoute("/_app/sales/expedients/")({
  component: ExpedientsPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(listExpedientsQueryOptions(deps as ListExpedientsSearch));
    }

    void queryClient.prefetchQuery(listExpedientsQueryOptions(deps as ListExpedientsSearch));

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: ExpedientsPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listExpedientsSearchSchema.parse(search),
});
